import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "./PublicHeader";
import { SectionLink } from "./SectionLink";
import { useAuthModal } from "./auth/AuthModalContext";

const linkClass =
  "font-body-sm text-body-sm text-outline-variant hover:text-surface-container-lowest transition-colors text-left";

const Column = ({ title, children }: { title: string; children: ReactNode }) => (
  <div className="flex flex-col items-start gap-3">
    <span className="font-label-lg text-label-lg text-surface-container-lowest font-semibold">
      {title}
    </span>
    {children}
  </div>
);

export const PublicFooter = () => {
  const { openAuth } = useAuthModal();

  return (
    <footer className="w-full bg-inverse-surface text-inverse-on-surface pt-16 pb-12 font-body-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-8 gap-y-10 lg:gap-12 pb-12 sm:pb-16">
          <div className="col-span-2 md:col-span-3 lg:col-span-2 flex flex-col items-start gap-4">
            <BrandMark light />
            <p className="font-body-md text-body-md text-outline-variant max-w-sm">
              Empowering students and professionals to ace their CELPIP and
              English proficiency tests with realistic practice exams and smart
              AI feedback.
            </p>
          </div>
          <Column title="Platform">
            <SectionLink section="categories" className={linkClass}>
              Features
            </SectionLink>
            <SectionLink section="practice-preview" className={linkClass}>
              Practice Tests
            </SectionLink>
            <SectionLink section="how-it-works" className={linkClass}>
              How It Works
            </SectionLink>
            <SectionLink section="pricing" className={linkClass}>
              Pricing
            </SectionLink>
          </Column>
          <Column title="Resources">
            <SectionLink section="faqs" className={linkClass}>
              FAQs
            </SectionLink>
            <Link to="/contact-us" className={linkClass}>
              Contact
            </Link>
            <button
              type="button"
              onClick={() => openAuth("signin")}
              className={linkClass}
            >
              Log In
            </button>
            <button
              type="button"
              onClick={() => openAuth("signup")}
              className={linkClass}
            >
              Create Account
            </button>
          </Column>
          <Column title="Legal & Trust">
            <Link to="/privacy-policy" className={linkClass}>
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" className={linkClass}>
              Terms &amp; Conditions
            </Link>
          </Column>
        </div>
        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-body-sm text-body-sm text-outline-variant text-center sm:text-left">
            © {new Date().getFullYear()} PassEnglishTest. All rights reserved.
            Designed for test-takers worldwide.
          </p>
        </div>
      </div>
    </footer>
  );
};
